var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.initialized,
          expression: "initialized"
        }
      ]
    },
    [
      _c("div", { staticClass: "hearing-aid-sales__filters" }, [
        _c(
          "div",
          { staticClass: "filter-sales-dates__from-date filter-selection" },
          [
            _c("div", { staticClass: "filter-selection__title" }, [
              _vm._v("From:")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-selection__body" },
              [
                _c("StoreConnectedDatePicker", {
                  staticClass:
                    "filter-selection__select filter-selection__select--date",
                  attrs: {
                    store: _vm.store,
                    action: _vm.action,
                    name: "dateFrom",
                    placeholder: "From",
                    format: "MMM yyyy",
                    "disabled-dates": _vm.disabledRangeFrom,
                    "minimum-view": "month"
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "filter-sales-dates__to-date filter-selection" },
          [
            _c("div", { staticClass: "filter-selection__title" }, [
              _vm._v("To:")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-selection__body" },
              [
                _c("StoreConnectedDatePicker", {
                  staticClass:
                    "filter-selection__select filter-selection__select--date",
                  attrs: {
                    store: _vm.store,
                    action: _vm.action,
                    name: "dateTo",
                    placeholder: "To",
                    format: "MMM yyyy",
                    "disabled-dates": _vm.disabledRangeTo,
                    "minimum-view": "month"
                  }
                })
              ],
              1
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }